import { sendCallFinalized } from '../services/callHistorySync';
import { useCallStore, type ActiveCall, type IncomingCall } from '../store/callStore';

function deriveFinalStatus(params: {
  activeCall?: ActiveCall | null;
  incomingCall?: IncomingCall | null;
  durationSeconds?: number;
  reason?: string;
}): 'answered' | 'ended' | 'failed' | 'rejected' {
  if ((params.durationSeconds || 0) > 0) return 'answered';
  if (params.reason === 'tab_rejected') return 'rejected';
  if (params.incomingCall && !params.activeCall) return 'failed';
  return 'ended';
}

export function markCallEndedInHistory(params: {
  callSessionId: string;
  activeCall?: ActiveCall | null;
  incomingCall?: IncomingCall | null;
  reason?: string;
  source?: 'ws' | 'webrtc' | 'user' | 'security' | 'unknown';
  durationSeconds?: number;
}) {
  const callSessionId = (params.callSessionId || '').trim();
  if (!callSessionId) return;

  const durationSeconds = typeof params.durationSeconds === 'number' && params.durationSeconds > 0
    ? Math.max(1, Math.floor(params.durationSeconds))
    : undefined;
  const finalStatus = deriveFinalStatus({
    activeCall: params.activeCall,
    incomingCall: params.incomingCall,
    durationSeconds,
    reason: params.reason
  });

  void sendCallFinalized({
    callSessionId,
    endedAt: Date.now(),
    finalStatus,
    durationSeconds,
    reason: params.reason,
    localIdentityId: params.activeCall?.localIdentityId || params.incomingCall?.localIdentityId,
    serverUrl: params.activeCall?.serverUrl || params.incomingCall?.localServerUrl
  }).catch(() => {});
}

export function getActiveCallDurationSeconds(): number | undefined {
  const startedAt = useCallStore.getState().activeCall?.startedAt;
  if (!startedAt) {
    return undefined;
  }
  const durationSeconds = Math.floor((Date.now() - startedAt.getTime()) / 1000);
  return durationSeconds > 0 ? durationSeconds : undefined;
}
